import React, { useContext } from 'react';
import HeaderMenuContext from 'utils/HeaderMenuContext';
import DetailedSubMenu from '../DetailedSubMenu';
import ResourceSubMenu from '../ResourceSubMenu';
import SimpleSubMenu from '../SimpleSubMenu';
import IndustrySubMenu from '../IndustrySubMenu';
import GroupSubMenu from '../GroupSubMenu';
import MenuItem from '../MenuItem';
import { MenuItemsContainer } from './styles';

const MenuItems = ({ isMobileMenuOpened, setMobileMenuOpened, navigationMenu }) => {
  const { openedMobileMenuInfo, setOpenedMobileMenuInfo } = useContext(HeaderMenuContext);
  const openedMenuIndex = openedMobileMenuInfo?.menuIndex;

  const getMenuType = main => {
    if (main.type) {
      return main.type;
    }

    if (main.label === 'Product Tour') {
      return 'product-menu';
    }

    if (main.label === 'Industries') {
      return 'industry-menu';
    }

    if (main.label === 'Solutions') {
      return 'solution-menu';
    }

    if (main.label === 'Resources') {
      return 'resource-menu';
    }

    return 'simple-menu';
  };

  const setIsMenuOpened = index => {
    setOpenedMobileMenuInfo({
      ...openedMobileMenuInfo,
      menuIndex: openedMenuIndex === index ? null : index,
    });
  };

  return (
    <MenuItemsContainer isMobileMenuOpened={isMobileMenuOpened}>
      {navigationMenu?.map((main, index) => {
        const { label, subNavigationElement, url } = main;
        const menuType = getMenuType(main);
        const hasSimpleMenu = main.subNavigationElement && menuType === 'simple-menu';

        return (
          <MenuItem
            type={menuType}
            title={label}
            hasSubMenu={!!subNavigationElement}
            link={url || '#'}
            key={index}
            isMenuOpened={openedMenuIndex === index}
            setMobileMenuOpened={setMobileMenuOpened}
            setIsMenuOpened={() => setIsMenuOpened(index)}
          >
            {menuType === 'product-menu' && (
              <DetailedSubMenu
                subNavElements={subNavigationElement}
                isMenuOpened={openedMenuIndex === index}
                setMobileMenuOpened={setMobileMenuOpened}
              />
            )}

            {menuType === 'industry-menu' && (
              <IndustrySubMenu
                subNavElements={subNavigationElement}
                isMenuOpened={openedMenuIndex === index}
                setMobileMenuOpened={setMobileMenuOpened}
              />
            )}

            {menuType === 'solution-menu' && (
              <GroupSubMenu
                subNavElements={subNavigationElement}
                isMenuOpened={openedMenuIndex === index}
                setMobileMenuOpened={setMobileMenuOpened}
              />
            )}

            {menuType === 'resource-menu' && (
              <ResourceSubMenu
                subNavElements={subNavigationElement}
                isMenuOpened={openedMenuIndex === index}
                setMobileMenuOpened={setMobileMenuOpened}
              />
            )}

            {hasSimpleMenu && (
              <SimpleSubMenu
                subNavElements={subNavigationElement}
                isMenuOpened={openedMenuIndex === index}
                setMobileMenuOpened={setMobileMenuOpened}
              />
            )}
          </MenuItem>
        );
      })}
    </MenuItemsContainer>
  );
};

export default MenuItems;
